import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useState } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import NoInfo from "../../components/NoInfo";
import { Column } from "primereact/column";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { queryFuncRoleMappingInfo, updateFuncRoleMappingInfo } from "../../utility/service/funclist-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { SystemLoading,checkLoading } from "../../store/loadingStore";
import { useEditableFlag } from "../../hooks/useEditableFlag";

export default function FuncList_RoleDetail(){
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [,loading] = useContext(SystemLoading);    
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([
        {
            companyNum:"1233666",
            companyName:"company A",
            roleSymbol:"Admin",
            roleName:"管理者"
        }
    ]);
    const [delDialog, setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const [delContent, setDelContent] = useState("");
    const isEditable = useEditableFlag('B20101');

    const cols = [
        { field: 'taxIdNum', header: t('company_num') },
        { field: 'companyName', header: t('organName')},
        { field: 'symbol', header: t('role_symbol')},
        { field: 'roleName', header: t('role_name')},
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            name:'',
            useType: []
        },
        //錯誤驗證時機
        mode: "all"
      });

      const btnBackTo = ()=>{
        navigate("/management/funcList");
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const onSubmit = (data) => {
       console.log('onSubmit',data);
       
    }

    const axios_queryFuncRoleMappingInfo = (reqBody,readMore=false)=>{
        checkLoading(loading);
        queryFuncRoleMappingInfo(reqBody)
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res?.data?.RespBody?.feRoleList;
                if(data?.length > 0){
                    if(readMore===true){
                      setRows((pre)=>{
                        return [...pre,...data] 
                      })
                    }else{
                      setRows((pre)=>{
                        return [...data]
                      });
                    }
                  }else{
                    if(readMore===false){
                      setRows([]);
                    }
                  }
                
            }else{
                if(readMore===false){
                  setRows([]);
                }
              }
        }).finally((fin)=>{checkLoading(loading,false);})
    }

    useEffect(()=>{
        if((action)!==''){
            axios_queryFuncRoleMappingInfo({funcId:itemObj?.funcId});
        }else{
            btnBackTo();
        }
    },[action])

    

    // 移除關聯角色
    const delRoleMapping = (item)=>{
        setDelDialog(true);
        setDelObj(item)
        setDelContent();

    }

    //查詢更多
    const btnReadMore = () => {
      
    };

    const confirmDel = ()=>{
        let reqBody = {
            rfSeqList:[{rfSeq:delObj?.rfSeq}]
        }
        axios_updateFuncRoleMappingInfo(reqBody);
    }

    const axios_updateFuncRoleMappingInfo = (reqBody)=>{
        updateFuncRoleMappingInfo(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    setDelDialog(false);
                    axios_queryFuncRoleMappingInfo({funcId:itemObj?.funcId});
                }
            })
    }
    
    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
          return (
            <>
                <Button tooltip={t('disassociate')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" disabled={!isEditable} onClick={() => { delRoleMapping(rowData) }}>
                  <FontAwesomeIcon icon="fa-solid fa-trash" />
                </Button>
            </>
    
          )
    
        }
      }

    return (<>
     {/* 返回上頁 */}
     <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            <div className="grid">
                    <div className="col-12 md:col-4">
                        <label>{t('funcId')}: </label>
                        <span>{itemObj?.funcId}</span>
                    </div>
                    <div className="col-12 md:col-4">
                        <label>{t('fun_name')}: </label>
                        <span>{itemObj?.name}</span>
                    </div>
            </div>
            
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rows}
            footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false} btnReadMore={btnReadMore} />}
            emptyMessage={<NoInfo panel="table"/>}
            >
                {
                    cols?.map((col, index) => {
                    return (
                        <Column key={index} field={col.field} header={col.header} />
                    )
                    })
                }
                <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
            </DataTable>
        </div>

    </div>

      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => { setDelDialog(false) }}
        onConfirm={() => { confirmDel(); }}
        title={t('button.delete')}
        bodyTemplate={<>
        <div dangerouslySetInnerHTML={{ __html: t('cf_del_roleMapping',{funcId:itemObj?.funcId})}}>
        </div>
        <div>{t('org_name')}: <span style={{color:'red'}}>{delObj?.companyName}</span> </div>
        <div>{t('role_symbol')}: <span style={{color:'red'}}>{delObj?.symbol}</span> </div>
        </>}
      />
    
    </>)
}